import { createFileRoute } from "@tanstack/react-router";

import { TenantPicker } from "../shell/TenantPicker";

/**
 * Outside `AppShell`, like `/login`: the shell's navigation is built from a bootstrap call that
 * needs a tenant, so it cannot render on the screen whose job is to choose one.
 */
export const Route = createFileRoute("/select-tenant")({
  head: () => ({
    meta: [
      { title: "Choose a tenant — LevelLoad" },
      { name: "description", content: "Choose a tenant — LevelLoad transport planning." },
    ],
  }),
  component: TenantPicker,
});
